import { getDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import { t } from "../i18n/translations";

export default function BottomNav({
  user,
  sharedMode,
  joinMode,
  activeTab,
  screen,
  lang,
  members,
  userProfile,
  setActiveTab,
  setScreen,
  setViewingMember,
  setViewingWishlist,
  setCurrentFamily,
  viewProfile,
  cameFromProfilePicker,
  currentFamily,
  viewingMember,
  viewingWishlist,
  coopCount,
  
}) {
  const tr = function(key) { return t(lang, key); };

  if (!user || sharedMode || joinMode) return null;

  const isWishluActive = activeTab === "wishlu" && (!cameFromProfilePicker || viewingMember?.id === user?.uid);
  const isGroupsActive = activeTab === "groups" || (activeTab === "wishlu" && cameFromProfilePicker && viewingMember?.id !== user?.uid);
  const isProfileActive = activeTab === "profile";

  return (
    <nav style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      background: "var(--color-surface, #1a1a1a)",
      borderTop: "1px solid var(--color-border, #2e2e2e)",
      zIndex: 100,
      paddingBottom: "env(safe-area-inset-bottom, 0px)",
    }}>
      <div style={{
        display: "flex",
        alignItems: "stretch",
        height: 56,
      }}>

       {/* ── MI WISHLU ── */}
<button
  className={"bottom-nav-item" + (isWishluActive ? " active" : "")}
  style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, background: "none", border: "none", cursor: "pointer", padding: "6px 4px" }}
  onClick={async function() {
  setActiveTab("wishlu");
  setScreen("profile");
  setViewingWishlist(null); // 👈 agrega esta línea
  setTimeout(function() { var p = document.querySelector(".pantalla"); if (p) p.scrollTop = 0; }, 20);

    const allWishlistIds = userProfile?.wishlists || [];
    if (allWishlistIds.length === 0) return;

    if (activeTab === "wishlu" && screen === "profile") {
      const currentWishlistId = viewingMember?.id === user?.uid ? (viewingWishlist?.id || null) : null;
      const currentIndex = currentWishlistId ? allWishlistIds.indexOf(currentWishlistId) : -1;
      const nextIndex = (currentIndex + 1) % allWishlistIds.length;
      const idToLoad = allWishlistIds[nextIndex];
      const wSnap = await getDoc(doc(db, "wishlists", idToLoad));
if (wSnap.exists()) {
  try { localStorage.setItem("whislu_last_wishlist", idToLoad); } catch(e) {}
  setViewingMember({ id: user.uid, ...userProfile });
  setViewingWishlist({ id: wSnap.id, ...wSnap.data() });
  setScreen("profile");
}
return;
    }

    const familyId = userProfile?.families?.[0] || "";
    const lastId = (() => { try { return localStorage.getItem("whislu_last_wishlist_" + familyId); } catch(e) { return null; } })();
    const idToLoad = (lastId && allWishlistIds.includes(lastId)) ? lastId : (userProfile?.familyWishlists?.[familyId] || allWishlistIds[0]);
    if (idToLoad) {
      const wSnap = await getDoc(doc(db, "wishlists", idToLoad));
      if (wSnap.exists()) {
        setViewingMember({ id: user.uid, ...userProfile });
        setViewingWishlist({ id: wSnap.id, ...wSnap.data() });
        setScreen("profile");
      }
    }
  }}
>
  <div className="bottom-nav-icon-wrap"><span className="bottom-nav-icon">🎁</span></div>
  <span className="bottom-nav-label">{tr("wishluTab")}</span>
</button>
        
        {/* ── GRUPOS ── */}
        <button
          className={"bottom-nav-item" + (isGroupsActive ? " active" : "")}
          style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, background: "none", border: "none", cursor: "pointer", padding: "6px 4px" }}
          onClick={function() {
  if (activeTab === "groups" && screen === "family") {
    // Segunda vez: resetear a lista de grupos
    setCurrentFamily(null);
    setViewingMember(null);
    setTimeout(function() { var p = document.querySelector(".pantalla"); if (p) p.scrollTop = 0; }, 20);
    return;
  }
  // Primera vez: ir a grupos con el último grupo visto
  setActiveTab("groups");
  setScreen("family");
  setViewingMember(null);
 
  setTimeout(function() { var p = document.querySelector(".pantalla"); if (p) p.scrollTop = 0; }, 20);
}}
        >
          <div className="bottom-nav-icon-wrap"><span className="bottom-nav-icon">👥</span></div>
          <span className="bottom-nav-label">{tr("groupsTab")}</span>
        </button>

        {/* ── PERFIL ── */}
        <button
          className={"bottom-nav-item" + (isProfileActive ? " active" : "")}
          style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, background: "none", border: "none", cursor: "pointer", padding: "6px 4px" }}
          onClick={function() {
            setActiveTab("profile");
            setScreen("family");
            setViewingWishlist(null);
            setViewingMember(null);
           
            setTimeout(function() { var p = document.querySelector(".pantalla"); if (p) p.scrollTop = 0; }, 20);
          }}
        >
  <div className="bottom-nav-icon-wrap" style={{ position: "relative" }}>
  <span className="bottom-nav-icon">👤</span>
  {coopCount > 0 && (
    <div style={{
      position: "absolute",
      top: -2, right: -2,
      width: 10, height: 10,
      borderRadius: "50%",
      background: "#e74c3c",
      border: "2px solid var(--color-surface, #1a1a1a)",
    }} />
  )}
</div>
  <span className="bottom-nav-label">{tr("profileTab")}</span>
        </button>

      </div>
    </nav>
  );
}
